import React from 'react';
import { motion } from 'framer-motion';
const features = ['bienestar', 'revisión consciente', 'higiene diaria', 'comodidad', 'organización personal', 'checklists fáciles de seguir'];
export function Features() {
  return <section className="py-20 bg-white" data-id="element-46">
      <div className="max-w-4xl mx-auto px-6 text-center" data-id="element-47">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.8
      }} data-id="element-48">
          <h2 className="text-3xl md:text-4xl font-serif mb-8" data-id="element-49">
            Una rutina simple también puede sentirse premium.
          </h2>

          <p className="text-lg text-charcoal-light mb-4 max-w-2xl mx-auto leading-relaxed" data-id="element-50">
            No necesitas una guía complicada ni llena de tecnicismos. Necesitas
            una herramienta práctica que te ayude a observar, cuidar y organizar
            mejor tu rutina diaria.
          </p>
          <p className="text-lg text-charcoal-light mb-10" data-id="element-51">
            Esta guía combina:
          </p>

          <div className="flex flex-wrap justify-center gap-3 mb-12" data-id="element-52">
            {features.map((feature, index) => <motion.span key={index} initial={{
            opacity: 0,
            scale: 0.9
          }} whileInView={{
            opacity: 1,
            scale: 1
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.4,
            delay: index * 0.1
          }} className="px-6 py-3 bg-cream text-charcoal border border-bronze/20 rounded-full text-sm font-medium tracking-wide" data-id="element-53">
                {feature}
              </motion.span>)}
          </div>

          <p className="text-xl font-serif italic text-bronze-dark" data-id="element-54">
            Todo en un formato claro, bonito y pensado para leerse con calma.
          </p>
        </motion.div>
      </div>
    </section>;
}